/**
 * Carrega todos os arquivos `.md` da pasta `src/content/instructions/`
 * em build-time via Vite glob import. A chave é o nome do arquivo sem `.md`.
 */
const modules = import.meta.glob('@/content/instructions/*.md', {
  query: '?raw',
  import: 'default',
  eager: true,
});

const registry: Record<string, string> = {};
for (const path in modules) {
  const match = path.match(/\/([^/]+)\.md$/);
  if (!match || !match[1]) continue;
  const key = match[1];
  registry[key] = modules[path] as string;
}

export type InstructionKey = string;

export function getInstruction(key: InstructionKey): string | null {
  return registry[key] ?? null;
}

export function listInstructionKeys(): InstructionKey[] {
  return Object.keys(registry).sort();
}
